import Guid from '../../models/Guid';

export enum TypeTabCalendrier {
    TypeUnite,
    GroupeTypeUnite,
    Carte
}

export interface ITypeUniteTabs {
    id: Guid;
    description: string;
    type: TypeTabCalendrier;
    typePeriode: number;
    nombreColonnes: number;
    tailleColonne: string;
    calDateDebut: Date;
    calDateFin: Date;
    dureePeriode?: number;
}

export interface ICellDateRange {
    debut: Date,
    fin: Date,
}

export interface ISelectedCells {
    idUnite: Guid,
    typePeriode: number,
    dates: ICellDateRange[],
    ligne: number,
    colonne: number
}

export enum TypeCalendrier {
    Minutes = 0,
    Heures = 1,
    Jours = 2,
    Mois = 3,
    Année = 4
}